import { render, staticRenderFns } from "./CityDetails.vue?vue&type=template&id=47546e25&scoped=true"
import script from "./CityDetails.vue?vue&type=script&lang=js"
export * from "./CityDetails.vue?vue&type=script&lang=js"
import style0 from "./CityDetails.vue?vue&type=style&index=0&id=47546e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47546e25",
  null
  
)

export default component.exports